// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"84226a69","625":"84226a69"}[chunkId] + ".chunk.css";
};